import { render, staticRenderFns } from "./siCarrierManager.vue?vue&type=template&id=3662ee10"
import script from "./siCarrierManager.vue?vue&type=script&lang=js"
export * from "./siCarrierManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports